import axios from "axios";
import { errorHandeling } from "../errorHandeling";
import { useState } from "react";
import { notifyToast } from "../libs/generalFunctions";

function useFetchAttach() {

//====state start here ====
const [LoadingFilesToDownload,setLoadingFilesToDownload] = useState(false);

const [errorFetchingFiles,setErrorFetchingFiles] = useState(null);

//====state end here====

//====Event handler start here====

const handleDownloadTheAttachs = async ( filesArr )=>{

let successDownloading = true;

setLoadingFilesToDownload(true);

setErrorFetchingFiles(null);

notifyToast("WAITING","يتم التحميل ...");

for( let i=0 ; i < filesArr.length ; i++ ){

    try {
        const response = await axios.get(
            filesArr[i].url ,
          {
             responseType: 'blob'
          }
        );

        let blob = response.data;
     
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', filesArr[i].name );
        document.body.appendChild(link);
        link.click();

        // Clean up the temporary elements and URL
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
    
      }  catch (error) {
        console.error('Error:', error);
        notifyToast("ERROR","حدث خطأ أثناء تحميل الملفات");
        successDownloading = false;
        setErrorFetchingFiles(errorHandeling(error));
      }
}

if( successDownloading ){
    notifyToast("SUCCESS","تمت العملية بنجاح");
}

setLoadingFilesToDownload(false);

}


//====Event handler end here====

  return { handleDownloadTheAttachs , LoadingFilesToDownload , errorFetchingFiles };
}

export default useFetchAttach;